import { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { Loader2 } from 'lucide-react';

export default function DemoEntryPage() {
  const { demoLogin } = useAuth();
  const [error, setError] = useState('');

  useEffect(() => {
    const startDemo = async () => {
      try {
        // Clear any previous tour state so voiceover tour shows fresh
        localStorage.removeItem('d3_product_tour');
        localStorage.removeItem('d3_tour_muted');
        sessionStorage.removeItem('d3_tour_auto_triggered');

        await demoLogin();

        // Navigate to dashboard (React navigation, not page reload)
        window.history.pushState({}, '', '/dashboard');
        window.dispatchEvent(new PopStateEvent('popstate'));
      } catch {
        setError('Unable to start demo. Please try again.');
      }
    };
    startDemo();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (error) {
    return (
      <div className="min-h-screen bg-[#07090F] flex items-center justify-center">
        <div className="text-center">
          <p className="text-red-400 mb-4">{error}</p>
          <a href="/" className="text-indigo-400 hover:text-indigo-300 text-sm">
            Back to home
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#07090F] flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-8 h-8 text-indigo-500 animate-spin mx-auto mb-3" />
        <p className="text-zinc-400 text-sm">Loading demo experience...</p>
      </div>
    </div>
  );
}
